import React from "react";
import { cn } from "@/lib/utils";

interface TimelineSliderProps {
  options: string[];
  value: string | number;
  onChange: (value: string) => void;
  className?: string;
}

export function TimelineSlider({
  options,
  value,
  onChange,
  className,
}: TimelineSliderProps) {
  const selectedIndex = typeof value === 'number' 
    ? value 
    : options.findIndex((opt) => opt === value);

  const handleClick = (index: number) => {
    onChange(options[index]);
  };

  return (
    <div className={cn("w-full", className)}>
      {/* Timeline Bar */}
      <div className="relative pt-2 pb-8">
        {/* Background line */}
        <div className="absolute top-6 left-0 right-0 h-1 bg-muted rounded-full" />
        
        {/* Progress line */}
        <div 
          className="absolute top-6 left-0 h-1 bg-primary rounded-full transition-all duration-300"
          style={{ width: `${(selectedIndex / (options.length - 1)) * 100}%` }}
        />
        
        {/* Options */}
        <div className="relative flex justify-between">
          {options.map((option, index) => (
            <button
              key={option}
              type="button"
              onClick={() => handleClick(index)}
              className="flex flex-col items-center group"
            >
              {/* Dot */}
              <div
                className={cn(
                  "w-4 h-4 rounded-full border-2 transition-all duration-200",
                  "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
                  index <= selectedIndex
                    ? "bg-primary border-primary scale-110"
                    : "bg-background border-muted-foreground/40 group-hover:border-primary/60"
                )}
              />
              
              {/* Label */}
              <span
                className={cn(
                  "mt-3 text-xs font-medium whitespace-nowrap transition-colors",
                  index === selectedIndex
                    ? "text-primary font-semibold"
                    : index < selectedIndex
                    ? "text-foreground"
                    : "text-muted-foreground group-hover:text-foreground"
                )}
              >
                {option}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
